import React from 'react';
import { useImagesContext } from '../../contexts/ImagesContext';
import ImageAnimation from './ImageAnimation';

export const BookOpenForward = ({ open }) => {
  const { images } = useImagesContext();

  return (
    <>
      {open && (
        <ImageAnimation
          imageUrl={images['book-forward.png']}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: 1920,
            height: 1080,
            zIndex: 9999,
          }}
        />
      )}
    </>
  );
};

export const BookOpenBackward = ({ open }) => {
  const { images } = useImagesContext();

  return (
    <>
      {open && (
        <ImageAnimation
          imageUrl={images['book-backward.png']}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: 1920,
            height: 1080,
            zIndex: 9999,
          }}
        />
      )}
    </>
  );
};
